import React, { Component } from 'react';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import logo from './logo_wind-creek-casino.png';
import menuIcon from './icon-menu-mobile.png';
import './HeaderMobile.css';
import PatronAssets from '../../containers/PatronAssets';
import MobileHamburgerMenu from 'components/MobileHamburgerMenu';
import { WINDCREEK_LEGACY_URL } from 'utils/constants';

const menuItems = [
  {
    name: 'Games',
    children: [
      {
        name: 'Game Lobby',
        url: '/mobile/games'
      },
      {
        name: 'Tournaments',
        url: '/mobile/tournaments'
      }
    ]
  },
  {
    name: 'Rewards',
    children: [
      {
        name: 'WStore',
        url: `${WINDCREEK_LEGACY_URL}/perfectcomp`
      },
      {
        name: 'Auctions',
        url: `${WINDCREEK_LEGACY_URL}/auction/list`
      },
      {
        name: 'My Rewards',
        url: `${WINDCREEK_LEGACY_URL}/perfectcomp/mycomps`
      },
      {
        name: 'Offers',
        url: `${WINDCREEK_LEGACY_URL}/offer/list`
      }
    ]
  },
  {
    name: 'Promos',
    children: [
      {
        name: 'Browse Drawings',
        url: `${WINDCREEK_LEGACY_URL}/drawings`
      }
    ]
  },
  {
    name: 'Members',
    children: [
      {
        name: 'My Friends',
        url: `${WINDCREEK_LEGACY_URL}/members`
      },
      {
        name: 'Browse Members',
        url: `${WINDCREEK_LEGACY_URL}/members/browse`
      },
      {
        name: 'Invite Friends',
        url: `${WINDCREEK_LEGACY_URL}/members/invite`
      }
    ]
  },
  {
    name: 'Terms Of Service',
    url: `${WINDCREEK_LEGACY_URL}/help/terms`
  },
  {
    name: 'Change Password',
    url: '/profile/change-password'
  }
];

class HeaderMobile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMobileMenu: false
    };

    this.openMobileMenu = this.openMobileMenu.bind(this);
    this.closeMobileMenu = this.closeMobileMenu.bind(this);
  }

  openMobileMenu() {
    this.setState({
      showMobileMenu: true
    });
  }

  closeMobileMenu() {
    this.setState({
      showMobileMenu: false
    });
  }

  render() {
    const { showMobileMenu } = this.state;

    return (
      <div className="header-mobile">
        <Navbar fixedTop fluid>
          <Navbar.Header>
            <img id="logo" src={logo} alt="Wind Creek" />
            <Nav className="right">
              <NavItem onClick={this.openMobileMenu}>
                <img src={menuIcon} alt="Menu" />
              </NavItem>
            </Nav>
            <PatronAssets isMobile={true} />
          </Navbar.Header>
        </Navbar>
        {showMobileMenu && (
          <MobileHamburgerMenu items={menuItems} close={this.closeMobileMenu} />
        )}
      </div>
    );
  }
}

export default HeaderMobile;



// WEBPACK FOOTER //
// ./src/components/HeaderMobile/index.js